import { fontReset } from '@adornis/fonts/font-resets.js';
import { XH4 } from '@adornis/fonts/fonts.js';
import '@chancenwerk/design/components/cr-flex.js';
import { customElement } from 'lit/decorators.js';

@customElement('cr-cta-text')
export class CRCTAText extends XH4 {
  override styles = () => {
    return super.styles().concat([fontReset('Indie Flower', 2, 400, 1, 14)]);
  };
}
